/**
 * Centralized route parameter names configuration
 *
 * Use these constants instead of hardcoded strings to ensure consistency
 * across guards, resolvers, and route definitions.
 */
export const ROUTE_PARAMS = {
  /**
   * Host ID parameter used in dynamic routes
   * Example: /:hostId/dashboard
   */
  HOST_ID: 'hostId',
} as const;

/**
 * Route path segments
 */
export const ROUTE_PATHS = {
  LOGIN: 'login',
  ONBOARDING: 'onboarding',
  DASHBOARD: 'dashboard',
  EVENTS: 'events',
  SALES: 'sales',
  ANALYTICS: 'analytics',
  ATTENDEES: 'attendees',
  MARKETING: 'marketing',
  SETTINGS: 'settings',
  HELP: 'help',
} as const;
